// The navbar exposes the selected viewer's controls without knowing its keys.
let controller = null;
const subscribers = new Set();
export const availableArtworkControls = () => !!controller;
export const showArtworkControls = () => { if (controller) controller(); };
export function subscribeArtworkControls(listener) {
  subscribers.add(listener);
  return () => subscribers.delete(listener);
}
export function registerArtworkControls(open) {
  controller = open;
  subscribers.forEach(listener => listener());
  return () => {
    if (controller !== open) return;
    controller = null;
    subscribers.forEach(listener => listener());
  };
}
